export default __webpack_public_path__ + "img/meta.00637375.webp";